import {
  TOGGLE_FULLSCREEN,
  SET_IS_HEADER_FIXED,
  TURN_OFF_FULLSCREEN,
  SET_LIST_TYPE,
  SHOW_TOAST,
  HIDE_TOAST,
  SHOW_TO_TOP_COMPONENT,
  SET_MOBILE,
  ADD_PAGE_FOLDER_CHILDREN_COUNT,
  RESET_FOLDER_CHILDREN_COUNT,
  SET_THEME,
  SET_WINDOW_SIZE,
  SHOW_TODOS_PANEL,
  CLOSE_TODOS_PANEL,
  TOGGLE_TODOS_PANEL,
  OPEN_SELECT_DIALOG,
  CLOSE_SELECT_DIALOG,
  SET_IS_EMBED,
  SET_IS_EMBED_WORDPRESS,
  SET_IS_PREVIEW,
  SET_IS_VIDEO,
  SET_IS_EMBED_HEADER_HIDDEN,
  SET_IS_FULL_WIDTH,
  SET_NOTE_FONT,
  SET_IS_SHARE_ACCESS_UPDATING,
  SET_IS_SHARE_PASSWORD_UPDATING,
  TOGGLE_OUTLINES,
  SET_IS_SHOW_OUTLINES,
  SET_IS_EMBED_PRINT_ENABLED, SET_IS_SHOW_SEARCH, SET_IS_SOCKET_CONNECTED, SET_IS_BRANDING_THEME_DISABLED,
} from './visual.actions';
export interface IToast {
  id: string;
  text: string;
  postition: string;
}

export interface IVisualState {
  isFullscreen: boolean;
  isFullWidth: boolean;
  isShowBackdrop: boolean;
  isHeaderFixed: boolean;
  isTodoPanelOpened: boolean;
  isShowToTopComponent: boolean;
  isShareAccessUpdating: boolean;
  isSharePasswordUpdating: boolean;
  isEditorReady: boolean;
  isMobile: boolean;
  listType: string;
  toasts: IToast[];
  folderChildrenCountToShow: number;
  theme: string;
  brandingThemeDisabled: boolean;
  windowHeight?: number;
  windowWidth?: number;
  isSelectDialogOpened: boolean;
  isEmbed: boolean;
  isWordpress: boolean;
  isPreview: boolean;
  isVideo: boolean;
  isEmbedHeaderHidden: boolean;
  isEmbedPrintEnabled: boolean;
  noteFont: string;
  isShowOutlines: boolean;
  isShowSearch: boolean;
  isSocketConnected: boolean;
}

export const visualInitialState: IVisualState = {
  isFullscreen: false,
  isFullWidth: false,
  isHeaderFixed: false,
  isShowBackdrop: true,
  isTodoPanelOpened: false,
  isShowToTopComponent: false,
  isShareAccessUpdating: false,
  isSharePasswordUpdating: false,
  isEditorReady: false,
  isMobile: false,
  listType: 'plates',
  folderChildrenCountToShow: 18,
  toasts: [],
  theme: 'day',
  brandingThemeDisabled: false,
  isSelectDialogOpened: false,
  isEmbed: false,
  isWordpress: false,
  isPreview: false,
  isVideo: false,
  isEmbedHeaderHidden: false,
  isEmbedPrintEnabled: false,
  noteFont: 'normal',
  isShowOutlines: true,
  isShowSearch: false,
  isSocketConnected: false,
};

const fullscreenOnEvent = new CustomEvent("toggleFullscreen", {detail:{fullscreen: true}})
const fullscreenOffEvent = new CustomEvent("toggleFullscreen", {detail:{fullscreen: false}})

export function visualReducer(state = visualInitialState, action) {
  switch (action.type) {
    case TOGGLE_FULLSCREEN:
      if (state.isFullscreen) {
        document.dispatchEvent(fullscreenOffEvent)
      } else {
        document.dispatchEvent(fullscreenOnEvent)
      }
      return Object.assign({}, state, {isFullscreen: !state.isFullscreen});
    case SET_IS_HEADER_FIXED:
      return Object.assign({}, state, {
        isHeaderFixed: action.value
      });
    case TURN_OFF_FULLSCREEN:
      return Object.assign({}, state, {
        isFullscreen: false
      });
    case SET_LIST_TYPE:
      return Object.assign({}, state, {
        listType: action.listType
      });
    case SHOW_TOAST:
      return Object.assign({}, state, {
        toasts: [...state.toasts, {
          id: action.id,
          text: action.text,
          position: action.position
        }]
      });
    case HIDE_TOAST:
      return Object.assign({}, state, {
        toasts: state.toasts.filter((toast) => toast.id !== action.id)
      });
    case SHOW_TO_TOP_COMPONENT:
      return Object.assign({}, state, {
        isShowToTopComponent: action.value
      });
    case SET_MOBILE:
      return Object.assign({}, state, {
        isMobile: action.value
      });
    case ADD_PAGE_FOLDER_CHILDREN_COUNT:
      return Object.assign({}, state, {
        folderChildrenCountToShow: state.folderChildrenCountToShow + visualInitialState.folderChildrenCountToShow
      });
    case RESET_FOLDER_CHILDREN_COUNT:
      return Object.assign({}, state, {
        folderChildrenCountToShow: visualInitialState.folderChildrenCountToShow
      });
    case SET_THEME:
      return Object.assign({}, state, {
        theme: action.theme ? action.theme : ""
      });
    case SET_IS_BRANDING_THEME_DISABLED:
      return Object.assign({}, state, {
        brandingThemeDisabled: action.value,
      });
    case SET_WINDOW_SIZE:
      return Object.assign({}, state, {
        windowHeight: action.height,
        windowWidth: action.width
      });
    case TOGGLE_TODOS_PANEL:
      return Object.assign({}, state, {
        isTodoPanelOpened: !state.isTodoPanelOpened
      });
    case SHOW_TODOS_PANEL:
      return Object.assign({}, state, {
        isTodoPanelOpened: true
      });
    case CLOSE_TODOS_PANEL:
      return Object.assign({}, state, {
        isTodoPanelOpened: false
      });
    case OPEN_SELECT_DIALOG:
      return Object.assign({}, state, {
        isSelectDialogOpened: true
      });
    case CLOSE_SELECT_DIALOG:
      return Object.assign({}, state, {
        isSelectDialogOpened: false
      });
    case SET_IS_EMBED:
      return Object.assign({}, state, {
        isEmbed: action.value
      });
    case SET_IS_EMBED_WORDPRESS:
      return Object.assign({}, state, {
        isWordpress: action.value
      });
    case SET_IS_PREVIEW:
      return Object.assign({}, state, {
        isPreview: action.value
      });
    case SET_IS_VIDEO:
      return Object.assign({}, state, {
        isVideo: action.value
      });
    case SET_IS_EMBED_PRINT_ENABLED:
      return Object.assign({}, state, {
        isEmbedPrintEnabled: action.value
      });
    case SET_IS_EMBED_HEADER_HIDDEN:
      return Object.assign({}, state, {
        isEmbedHeaderHidden: action.value
      });
    case SET_IS_FULL_WIDTH:
      return Object.assign({}, state, {
        isFullWidth: action.value
      });
    case SET_NOTE_FONT:
      return Object.assign({}, state, {
        noteFont: action.value
      });
    case SET_IS_SHARE_ACCESS_UPDATING:
      return Object.assign({}, state, {
        isShareAccessUpdating: action.value
      });
    case SET_IS_SHARE_PASSWORD_UPDATING:
      return Object.assign({}, state, {
        isSharePasswordUpdating: action.value
      });
    case TOGGLE_OUTLINES:
      const isShowOutlines = state.isShowOutlines;
      return Object.assign({}, state, {
        isShowOutlines: !isShowOutlines
      });
    case SET_IS_SHOW_OUTLINES:
      return Object.assign({}, state, {
        isShowOutlines: action.value
      });
    case SET_IS_SHOW_SEARCH:
      return Object.assign({}, state, {
        isShowSearch: action.value
      });
    case SET_IS_SOCKET_CONNECTED:
      return Object.assign({}, state, {
        isSocketConnected: action.value
      });
    default:
      return state;
  }
}
